import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { UserPricingView } from '../model/user-pricing-view';

import { LoadingSpinnerService } from "./loading-spinner.service";
import { AuthenticatedHttpService } from './authenticatedhttp.service';


@Injectable()
export class UserPricingViewService {
    private baseUrl;

    constructor(
        private _http: AuthenticatedHttpService
    ) {
        this.baseUrl = this._http.getBaseURLFromCookie();
    }

    getUserPricingView(userId: number): Observable<UserPricingView> {
        return this._http.get(`${this.baseUrl}/api/pricing-view/${userId}`)
            .map(x => x.json())
            .catch(this._http.handleError);
    }

    saveUserPricingView(userPricingView: UserPricingView): Observable<UserPricingView> {
        let jsonBody = userPricingView;
		return this._http.put(`${this.baseUrl}/api/pricing-view/save`, JSON.stringify(jsonBody))
			.map(x => x.json())
            .catch(this._http.handleError);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/user-pricing-view.service.ts